import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState, useSelector } from 'src/store';
import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import { editBtnAgain, editBtnText } from 'src/store/modules/buttons';
import { TEMPLATES_EDITOR_REGARCY } from 'src/constants/templates';
import { editLogCustom, editTracking } from 'src/store/modules/trackings';
import { hexToCSSFilter } from 'hex-to-css-filter';
import { editStarIndex } from 'src/store/modules/imageUpload';

const SELECTED_FILTER = hexToCSSFilter('#4778FF');
const NONE_FILTER = hexToCSSFilter('#ffffff');
const STAR_IMAGE = 'https://image.inappmessage.com/sample/black-star.png';
const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    backgroundColor: '#fff'
  },

  branchBox: {
    width: '100%',
    padding: 16,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px'
  },
  title: {
    color: '#000',
    titleAlign: 'center',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 600,
    letterSpacing: '0.0175rem'
  },
  subTitle: {
    color: '#4F4F4F',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400
  },

  settingBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '8px'
  },
  circle: {
    width: 24,
    height: 24,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    cursor: 'pointer',
    color: '#fff',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,

    borderRadius: 24,
    border: '2px solid #000',
    background: '#000',
    zIndex: 1
  },
  text: {
    color: '#4f4f4f',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal'
  },

  selectionBox: {
    width: '100%',
    marginTop: 2,
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative'
  },
  line: {
    width: '100%',
    height: 2,

    position: 'absolute',
    top: '50%',
    transform: 'translate(0%, -50%)',
    border: 0,
    background: '#000'
  }
}));

const EditMultiBranchOption = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let starIndex = useSelector(
    (state: RootState) => state.imageUpload.starIndex
  );

  const handleCurrentIndex = (idx: number) => {
    dispatch(editStarIndex(idx));
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.branchBox}>
        <Box className={classes.title}>BRANCH OPTION</Box>
        <Box className={classes.subTitle}>
          * Set your branching points based on the star ratings below.
        </Box>
        {[...Array(2)].map((_, idx) => {
          return (
            <Box key={idx} className={classes.settingBox}>
              <Box
                className={classes.circle}
                style={{ background: idx === 0 ? '#fff' : '#000' }}
              ></Box>
              <span className={classes.text}>
                2-{idx + 1} Star ratings in questions
              </span>
            </Box>
          );
        })}

        <Box className={classes.selectionBox}>
          <Box
            className={classes.line}
            style={{
              background: `linear-gradient(to right, #000 calc(${starIndex *
                24}%), #e0e0e0 calc(${starIndex * 24}%))`
            }}
          />
          {[...Array(5)].map((_, idx) => {
            return (
              <Box
                key={idx}
                className={classes.circle}
                onClick={() => idx !== 4 && handleCurrentIndex(idx)}
                style={
                  idx <= starIndex
                    ? {
                        color: '#000',
                        outline: `${idx === starIndex ? 3 : 0}px solid #000`,
                        background: '#fff'
                      }
                    : {}
                }
              >
                {idx + 1}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default EditMultiBranchOption;
